import { render } from "./PanelPublicistaRanking.vue?vue&type=template&id=3e4bd3d0&scoped=true"
import script from "./PanelPublicistaRanking.vue?vue&type=script&lang=js"
export * from "./PanelPublicistaRanking.vue?vue&type=script&lang=js"

import "./PanelPublicistaRanking.vue?vue&type=style&index=0&id=3e4bd3d0&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4bd3d0"]])

export default __exports__